import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerService } from '../../../services/spinner.service';
import swal from 'sweetalert2';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { SnackbarService } from '../../../services/snackbar.service';
import { WasteManagersContactDialogComponent } from '../waste-managers-contact-dialog/waste-managers-contact-dialog.component';
import { ContactoControllerService, ContactoDTO, GestoresResiduosControllerService, GestoresResiduosDTO } from 'api-rest';
@Component({
  selector: 'lib-waste-managers-detail-contact-data',
  templateUrl: './waste-managers-detail-contact-data.component.html',
  styleUrls: ['./waste-managers-detail-contact-data.component.scss'],
})
export class WasteManagersDetailContactDataComponent
  implements OnInit, OnChanges
{
  @Input() gestorInfo!: GestoresResiduosDTO;
  @Output() public refrescarGestorEvent = new EventEmitter<any>();
  contactos: any;

  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  gridArray: any[] = [];

  headArray: any = [
    {
      Head: 'Requerida',
      FieldName: 'requerido',
      check: true,
      disabled: true,
    },
    {
      Head: 'Tipo contacto',
      FieldName: 'tipo_contacto',
      Attribute: 'descripcionCorta',
      Tooltip: true,
    },
    {
      Head: 'Tipo entidad',
      renderValue: (value: any) => value.persona ? 'Persona' : 'Empresa'
    },
    {
      Head: 'Nombre/Razón Social',
      FieldName: 'fullName',
      Tooltip: true,
    },
    {
      Head: 'Activo',
      FieldName: 'obsoleto',
      renderValue: (item: any) => (item.obsoleto ? 'NO' : 'SI'),
    },
    {
      Head: 'Email  ',
      FieldName: 'email',
      Tooltip: true,
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle',
          show: { params: 'canAccessView', accion: 'view' },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'activate',
              name: 'Activar',
              show: { params: 'canAccessActivate', accion: 'activate' },
            },
            {
              nameButton: 'obsolete',
              name: 'Marcar como obsoleto',
              show: { params: 'canAccessObsolete', accion: 'obsolete' },
            },
          ],
        },
      ],
      width: '8',
      permanent: true,
    },
  ];

  constructor(
    private dialog: MatDialog,
    private spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private contactoControllerService: ContactoControllerService,
    private gestoresResiduosControllerService: GestoresResiduosControllerService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.gestorInfo) {
      this.contactos = this.gestorInfo?.contactos;
      this.gridArray = this.canAccessAll(this.contactos);
    }
  }

  canAccessNewContact(): boolean {
    return (
      this.authService.can('poseedores-gestor-contactos', 'create') &&
      this.gestorInfo.gestoresResiduosEstado! &&
      [1, 2].includes(this.gestorInfo?.gestoresResiduosEstado?.id!)
    );
  }

  canAccessAll(list: any) {
    const resultListShow = this.authService.can(
      'poseedores-gestor-contactos',
      'access'
    );
    const resultDelete = this.authService.can(
      'poseedores-gestor-contactos',
      'delete'
    );

    const listPermission = list.map((objeto: any) => {
      const estadoEditable =
        this.gestorInfo.gestoresResiduosEstado &&
        [1, 2].includes(this.gestorInfo?.gestoresResiduosEstado?.id!);
      const noRequerido = !objeto.requerido || objeto.requerido === null;
      const esActivo = !objeto.obsoleto;
      return {
        ...objeto,
        canAccessView: resultListShow,
        canAccessDelete: resultDelete && estadoEditable && noRequerido,
        canAccessObsolete: esActivo && estadoEditable,
        canAccessActivate: !esActivo && estadoEditable,
      };
    });

    return listPermission;
  }

  openModalContact(element?: any): void {
    const dialogRef = this.dialog.open(WasteManagersContactDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        contacto: element,
        gestorInfo: this.gestorInfo,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarGestorEvent.emit(true);
      }
    });
  }
  checked(item: any) {}

  action(item: any) {
    if (item.nameButton == 'view') {
      this.openModalContact(item);
    } else if (item.nameButton == 'edit') {
      this.openModalContact(item);
    } else if (item.nameButton == 'delete') {
      this.confirmacionEliminar(item);
    } else if (item.nameButton == 'activate') {
      this.comprobarContactosActivos(item);
    } else if (item.nameButton == 'obsolete') {
      this.confirmacionMarcarObsoleto(item);
    }
  }
  confirmacionEliminar(element?: any): void {
    swal
      .fire({
        text: '¿Desea eliminar el contacto?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.eliminarContacto(element);
        }
      });
  }
  eliminarContacto(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.contactoControllerService.borrarContacto(element.id).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'El contacto se ha eliminado correctamente',
            'success'
          );
          this.refrescarGestorEvent.emit(true);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al eliminar el contacto',
            'error'
          );
          console.log(err);
        },
      });
    }
  }

  renderPage(event: number) {
    this.pageNumber = event;
  }

  comprobarContactosActivos(element?: ContactoDTO): void {
    //Si el contacto es de tipo Firmante o Rep Autorizado, solo puede haber uno activo de cada tipo (incluyendo Empresa/Persona en caso de Rep Autorizado)
    if (element?.tipo_contacto?.id == 3 || element?.tipo_contacto?.id == 4) {
      let contactoExistente: any = null;
      if (element?.tipo_contacto?.id == 3) {
        contactoExistente = this.contactos?.filter((pContacto: any) => !pContacto.obsoleto && pContacto.tipo_contacto.id == element?.tipo_contacto?.id)[0];
      } else {
        contactoExistente = this.contactos?.filter((pContacto: any) => !pContacto.obsoleto && pContacto.tipo_contacto.id == element?.tipo_contacto?.id && pContacto.persona == element?.persona)[0];
      }
      if (contactoExistente) {
        swal.fire({
          text: `No está permitido activar otro contacto de tipo Firmante o Representante autorizado puesto que ya existe uno activo. ¿Quiere marcar el contacto existente como obsoleto?`,
          icon: 'question',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Sí',
          denyButtonText: 'No',
          allowOutsideClick: false,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.activarContacto(element, contactoExistente);
          }
        });
      } else {
        this.activarContacto(element);
      }
    } else {
      this.activarContacto(element);
    }
  }

  activarContacto(element?: any, contactoExistente?: any) {
    if (element?.id) {
      if (contactoExistente) {
        contactoExistente.obsoleto = true;
        const pContacto: any = this.gestorInfo?.contactos?.filter((item: any) => item.id == element.id)[0];
        pContacto.obsoleto = false;
        this.spinnerSrv.loadingShow();
        this.gestoresResiduosControllerService
          .editById4(this.gestorInfo.id!, this.gestorInfo as any)
          .subscribe({
            next: (response) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'El contacto se ha activado correctamente',
                'success'
              );
              this.refrescarGestorEvent.emit(true);
            },
            error: (err) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'Ha ocurrido un error al activar el contacto',
                'error'
              );
              console.log(err);
            },
          });
      } else {
        element.obsoleto = false;
        this.spinnerSrv.loadingShow();
        this.contactoControllerService.actualizarContacto(element.id, element).subscribe({
          next: (response) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'El contacto se ha activado correctamente',
              'success'
            );
            this.refrescarGestorEvent.emit(true);
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al activar el contacto',
              'error'
            );
            console.log(err);
          },
        });
      }
    }
  }

  confirmacionMarcarObsoleto(element?: ContactoDTO): void {
    swal
      .fire({
        text: '¿Desea marcar el contacto como obsoleto?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.marcarContactoObsoleto(element);
        }
      });
  }

  marcarContactoObsoleto(element?: any) {
    if (element?.id) {
      element.obsoleto = true;
      this.spinnerSrv.loadingShow();
      this.contactoControllerService.actualizarContacto(element.id, element).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'El contacto se ha marcado como obsoleto',
            'success'
          );
          this.refrescarGestorEvent.emit(true);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al marcar el contacto como obsoleto',
            'error'
          );
          console.log(err);
        },
      });
    }
  }
}
